// extracted by mini-css-extract-plugin
export var disabled = "_2m-5";
export var fileName = "_2m-b";
export var filePreview = "_2m-4";
export var hoverFilter = "_2m-6";
export var imageButton = "_2m-3 _2m-6";
export var imageButtonContainer = "_2m-2";
export var input = "_2m-7";
export var removeButton = "_2m-0";
export var removeButtonFile = "_2m-1";
export var spinner = "_2m-9";
export var spinnerContainer = "_2m-8";
export var videoContainer = "_2m-a _2m-6";